import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { applyColorSchema } from './helpers/color-schema';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import NotificationProvider from './resources/notification/notification-provider';
import { initTealium } from './tealium-init';

// Initialize Tealium
initTealium();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <NotificationProvider>
      <App />
    </NotificationProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
applyColorSchema();
